import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { checkMobile } from '@/utils/device'
import { loadPageData } from '@/services/dataService'

Vue.use(VueRouter)

const MainLayout = () => import('@/layouts/MainLayout.vue')
const MobileLayout = () => import('@/layouts/MobileLayout.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true, title: '登录' }
  },
  {
    path: '/',
    component: () => (checkMobile() ? MobileLayout() : MainLayout()),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '实时看板', mobile: true }
      },
      {
        path: 'zone',
        name: 'ZoneManage',
        component: () => import('@/views/ZoneManage.vue'),
        meta: { title: '工区管理', mobile: false }
      },
      {
        path: 'device',
        name: 'DeviceManage',
        component: () => import('@/views/DeviceManage.vue'),
        meta: { title: '设备管理', mobile: false }
      },
      {
        path: 'trace',
        name: 'TracePlayback',
        component: () => import('@/views/TracePlayback.vue'),
        meta: { title: '轨迹回放', mobile: true }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: () => import('@/views/SystemSettings.vue'),
        meta: { title: '系统设置', mobile: false }
      }
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!store.state.auth.user
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (to.meta.public) {
    if (isLoggedIn && to.name === 'Login') {
      next({ name: 'Dashboard' })
    } else {
      next()
    }
    return
  }

  if (requiresAuth && !isLoggedIn) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  if (checkMobile() && to.meta.mobile === false) {
    next({ name: 'Dashboard' })
    return
  }

  if (requiresAuth && isLoggedIn && to.name) {
    loadPageData(to.name, store.state.auth.user)
      .then(() => next())
      .catch(() => next())
    return
  }

  next()
})

export default router
